import React from 'react';

import './index.css';

import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Toolbar, 
    Divider,
    List, 
    ListItem, 
    ListItemText,
    Box,
    Button,
    Tooltip,
    InputBase,
    IconButton,
    TextField,
    InputAdornment,
    Typography
} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import Loading from '../../Loading';

import CloseIcon from '@mui/icons-material/Close'

import SearchIcon from '@mui/icons-material/Search';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import GroupsIcon from "@mui/icons-material/Groups"

import Alert from '@mui/material/Alert';
import api from '../../../api';
import { alphabeticalSort } from '../../../utils/alphabeticalSort';

import { getSession } from "../../../auth"

class TransferDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedQueue: null,
            showAlert: true,
            onlineQueues: [],
            loading: false,
            searchQuery: '', 
            transferNote: ""
        }
    }

    circle = (color = "") => {
        const shapeStyles = { width: 20, height: 20, boxShadow: '1px 1px 6px 0px #0000007a' };
        const shapeCircleStyles = { borderRadius: '50%' };
        const setColor = color ? color : 'primary.main'
        return (
            <Box component="span" sx={{ ...shapeStyles, ...shapeCircleStyles, bgcolor: setColor }} />
        );
    }

    submit = () => {
        this.setState({ showAlert: true });
        this.props.transferChat(this.state.selectedQueue, this.state.transferNote, this.state.queueDescription);
    }

    hideAlert = () => {
        this.setState({ showAlert: false });
    }

    getOnlineQueues = async () => {
        const res = await api.get(`/api/enterprises/${this.props.enterpriseId}/users/queue_online_users/`)

        if (res.status == 200) 
            this.setState({ onlineQueues: res.data }) 
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showAlert !== this.state.showAlert) {
            if (this.state.showAlert)
                this.getOnlineQueues()
        }
    }

    componentWillMount = () => {
        this.getOnlineQueues()
    }

    handleSearchChange = (event) => { 
        this.setState({ searchQuery: event.target.value }); 
    }

    getFilteredQueues = () => { 
        const { searchQuery } = this.state; 
        // const { queues } = this.props;
        const queues = getSession().profile.enterprise.queues
        return queues.filter(queue => queue.description.toLowerCase().includes(searchQuery.toLowerCase())); 
    }

    render() {
        const filteredQueues = this.getFilteredQueues();
        const selectedQueue = this.state.selectedQueue;
        const selectedIsOnline =
            !!selectedQueue && this.state.onlineQueues.includes(selectedQueue);
        const enterpriseQueues = (getSession()?.profile?.enterprise?.queues) || [];
        const selectedQueueObj = enterpriseQueues.find(q => q.name === selectedQueue);
        const selectedJoinEmpty = !!Number(selectedQueueObj?.joinempty); // joinempty vem 0/1
        
        //Regra: permite se online OU (offline e joinempty = 1)
        const canTransfer = !!selectedQueue && (selectedIsOnline || selectedJoinEmpty);
        const transferDisabledReason = !selectedQueue
            ? "Selecione uma fila"
            : !selectedIsOnline && !selectedJoinEmpty
                ? "Essa fila não recebe chamadas sem operadores disponíveis"
                : "";
        
        return (
            <div>
                {this.state.loading ? <Loading loading={true} /> : null}
                <Dialog keepMounted
                    open={this.props.open}
                    onClose={this.props.handleClose}
                    aria-labelledby="customized-dialog-title"
                    fullWidth
                    maxWidth="sm"
                    disableEnforceFocus
                >
                    <DialogTitle id="customized-dialog-title" className={'group-flexbox'}>
                        <span>{this.props.title}</span>
                        {this.props.queueName &&
                            <div id="currentQueue">
                                <GroupsIcon /> 
                                {this.props.queueName}
                            </div>
                        }
                        <Tooltip title="Fechar" >
                            <Button className="action-button">
                                <CloseIcon onClick={this.props.handleClose} />
                            </Button>
                        </Tooltip>
                    </DialogTitle>
                    <Divider />
                    <DialogContent ref={instance => { this.content = instance; }}>
                        <TextField
                            className={'inputPlaceholder'}
                            placeholder='Buscar fila'
                            onChange={this.handleSearchChange}
                            variant="outlined"
                            size="small"
                            sx={{ marginTop: '.4rem', marginBottom: '.4rem', backgroundColor: '#EFEFEF' }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            fullWidth
                        />
                        <List className="transfer-queue-list">
                            {filteredQueues.sort((x, y) => alphabeticalSort(x, y, 'description')).map((queue, i) => { 
                                const isOnline = this.state.onlineQueues.includes(queue.name);
                                return (
                                    <Toolbar key={i} sx={{ padding: 'unset !important' }} title={isOnline ? 'Há operadores disponíveis para atender.' : 'Não há operadores disponíveis para atender.'} >
                                        <ListItem className={this.state.selectedQueue === queue.name
                                            ? "transfer-item selected"
                                            : "transfer-item"}
                                            key={i}
                                        >
                                            <ListItemText primary={queue.description}
                                                secondary={queue.name.split('_')[1]}
                                                onClick={() => this.setState({ selectedQueue: queue.name, queueDescription: queue.description })} />
                                            {isOnline ?
                                                <>
                                                    {this.circle('#17E917')}
                                                </>
                                                :
                                                <>
                                                    {this.circle('gray')}
                                                </>
                                            }
                                            
                                        </ListItem>
                                    </Toolbar>
                                );
                            })}
                            {filteredQueues.length === 0 && 
                                <Box>Não há filas para transferir</Box>
                            }
                        </List>
                        <Typography fontSize="1.05rem" fontWeight="500" color="#21446c">Adicionar nota à transferência (opcional)</Typography>
                        <TextField label="Nota" multiline rows={4} variant="outlined" fullWidth 
                            sx={{ marginTop: ".5rem" }} 
                            value={this.state.transferNote}
                            onChange={(event) => this.setState({ transferNote: event.target.value })}
                        />
                        {this.props.error !== null && this.state.showAlert &&
                            <>
                                <Alert severity="error"
                                    onClose={this.hideAlert}>
                                    {this.props.error}
                                </Alert>
                            </>
                        }
                    </DialogContent>
                    <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                        <Button color="primary" onClick={this.props.handleClose}>
                            Cancelar
                        </Button>
                        <Tooltip
                            title={!canTransfer ? transferDisabledReason : ""}
                            disableHoverListener={canTransfer}
                            disableFocusListener={canTransfer}
                            disableTouchListener={canTransfer}
                        >
                            <span>
                                <LoadingButton
                                    onClick={() => this.submit()}
                                    color="primary"
                                    disabled={!canTransfer}
                                    loading={this.props.submitButtonLoading}
                                >
                                    Transferir
                                </LoadingButton>
                            </span>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            </div >
        );
    }
}

export default TransferDialog;
